import { createFileRoute } from '@tanstack/react-router'
import { Solicitacoes } from '@/features/solicitacoes/Solicitacoes'

export const Route = createFileRoute('/_app/app/solicitacoes')({
  staticData: { crumb: { label: 'Solicitações' } },
  component: Solicitacoes,
})
